// ======================================================================
// FILE: src/modules/wms/services/wmsSLAService.js
// MODULE: Work Management System (WMS)
// FEATURE: SLA Management API Service
//
// PURPOSE:
//   Frontend API client for SLA Management
//
// BACKEND:
//   /api/wms/sla-policies
// ======================================================================

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * LIST SLA POLICIES
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/sla-policies
 */
async function listSLAPolicies(params = {}) {

  const res = await axiosClient.get(
    "/api/wms/sla-policies",
    { params }
  );

  const payload = res.data?.data || {};

  return {
    items: payload.data || [],
    pagination: payload.pagination || {},
  };
}

/**
 * ----------------------------------------------------------------------
 * GET SLA POLICY
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/sla-policies/:id
 */
async function getSLAPolicy(policyId) {

  const res = await axiosClient.get(
    `/api/wms/sla-policies/${policyId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE SLA POLICY
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/sla-policies
 */
async function createSLAPolicy(payload) {

  const res = await axiosClient.post(
    "/api/wms/sla-policies",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE SLA POLICY
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/sla-policies/:id
 */
async function updateSLAPolicy(
  policyId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/sla-policies/${policyId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE SLA POLICY
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/sla-policies/:id
 */
async function deleteSLAPolicy(policyId) {

  const res = await axiosClient.delete(
    `/api/wms/sla-policies/${policyId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * GET SLA RULES
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/sla-policies/:id/rules
 */
async function getRules(policyId) {

  const res = await axiosClient.get(
    `/api/wms/sla-policies/${policyId}/rules`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * CREATE SLA RULE
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/sla-policies/:id/rules
 */
async function createRule(
  policyId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/sla-policies/${policyId}/rules`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE SLA RULE
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/sla-policies/:policyId/rules/:ruleId
 */
async function updateRule(
  policyId,
  ruleId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/sla-policies/${policyId}/rules/${ruleId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE SLA RULE
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/sla-policies/:policyId/rules/:ruleId
 */
async function deleteRule(
  policyId,
  ruleId
) {

  const res = await axiosClient.delete(
    `/api/wms/sla-policies/${policyId}/rules/${ruleId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
const wmsSLAService = {

  listSLAPolicies,
  getSLAPolicy,

  createSLAPolicy,
  updateSLAPolicy,
  deleteSLAPolicy,

  getRules,
  createRule,
  updateRule,
  deleteRule,
};

export default wmsSLAService;